// Dialogo modal: aparece desde arriba con resorte, oscurece el fondo, Esc o clic afuera cierran.
import { useEffect, useRef, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { esMovil } from '../hooks';
import { SpringValue, reducedMotion } from '../lib/spring';

export function Dialog({ titulo, subtitulo, onClose, children, width }: { titulo: string; subtitulo?: string; onClose: () => void; children: ReactNode; width?: number }) {
  const ref = useRef<HTMLDivElement>(null);
  const scrim = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    const sc = scrim.current;
    const previo = document.activeElement as HTMLElement | null;
    // En el celular (D100) el dialogo es una hoja que sube desde abajo, al alcance del pulgar.
    const movil = esMovil();
    if (el && sc && !reducedMotion()) {
      new SpringValue(0, (p) => {
        el.style.opacity = String(Math.min(1, p * (movil ? 3 : 1.2)));
        el.style.transform = movil ? `translateY(${(1 - p) * 60}%)` : `translateX(-50%) translateY(${(1 - p) * -12}px) scale(${0.97 + 0.03 * p})`;
        sc.style.opacity = String(p);
      }).go(1, { response: movil ? 0.36 : 0.32 });
    }
    const first = el?.querySelector<HTMLElement>('input,select,textarea,button:not([data-close])');
    first?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onClose();
      }
    };
    window.addEventListener('keydown', onKey, true);
    return () => {
      window.removeEventListener('keydown', onKey, true);
      previo?.focus?.();
    };
  }, [onClose]);

  return createPortal(
    <>
      <div className="scrim" ref={scrim} onClick={onClose} />
      <div className="dialog" ref={ref} role="dialog" aria-modal="true" aria-label={titulo} style={width && !esMovil() ? { width: `min(${width}px, calc(100% - 32px))` } : undefined}>
        <div className="hoja-agarre" aria-hidden>
          <span />
        </div>
        <h2>{titulo}</h2>
        {subtitulo ? <p className="dsub">{subtitulo}</p> : <div style={{ height: 10 }} />}
        {children}
      </div>
    </>,
    document.body,
  );
}
